import React from 'react'
import styled from '@emotion/styled'

import {Box} from '@vio/atlas/helpers/Box'
import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'
import {cssTheme} from '@vio/atlas/themes'

const CardsRow = styled.div`
  display: flex;
  gap: ${cssTheme.layout.spacing.s400};
  overflow: hidden;
  margin-right: calc(-1 * ${cssTheme.layout.spacing.s500});
`

const CardSkeleton = styled.div`
  width: 156px;
  min-width: 156px;
  flex-shrink: 0;
`

export const BetterValueCarouselSkeleton = () => {
  return (
    <CardsRow>
      {[1, 2, 3].map(index => (
        <CardSkeleton key={index}>
          <Box
            display="flex"
            flexDirection="column"
            borderColor="border.neutral.secondary"
            borderWidth="bw100"
            borderStyle="solid"
            borderRadius="lg"
            overflow="hidden"
          >
            <Box height="88px">
              <SkeletonLoader height="100%" />
            </Box>

            <Box
              display="flex"
              flexDirection="column"
              gap="s600"
              padding="s500"
            >
              <div>
                <SkeletonLoader width={86} />
                <SkeletonLoader width={56} />
              </div>
              <SkeletonLoader width={56} align="right" marginTop={0} />
            </Box>
          </Box>
        </CardSkeleton>
      ))}
    </CardsRow>
  )
}
